import { Box, Typography } from "@mui/material";
import { useState } from "react";
import { LocalizedLink } from "../../../LocalizedLink";
import { l_footer } from "../locales";

const PolicySection = () => {
  const [currentYear, setCurrentYear] = useState(() =>
    new Date().getFullYear()
  );

  return (
    <Box
      sx={{
        marginTop: "24px",
        display: "flex",
        flexDirection: { md: "row", xs: "column" },
        justifyContent: "space-between",
        gap: "8px",
      }}
    >
      <Box sx={{}}>
        <Typography
          sx={{
            fontSize: "10px",
            lineHeight: "12px",
            textTransform: "uppercase",
            color: "white",
          }}
        >
          Copyright {currentYear}
          {l_footer("policySection.copyright")}
        </Typography>
      </Box>
      <Box sx={{}}>
        <Typography
          sx={{
            fontSize: "10px",
            lineHeight: "12px",
            textTransform: "uppercase",
            color: "white",
          }}
        >
          <LocalizedLink
            to="/privacy"
            style={{ textDecoration: "none", color: "inherit" }}
            openInNewWindow
          >
            {l_footer("policySection.privacy")}
          </LocalizedLink>{" "}
          -{" "}
          <LocalizedLink
            to="/cookies"
            style={{ textDecoration: "none", color: "inherit" }}
            openInNewWindow
          >
            {l_footer("policySection.cookies")}
          </LocalizedLink>
        </Typography>
      </Box>
    </Box>
  );
};

export default PolicySection;
